import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const GradientCircularProgressbar = ({ value }) => {
  return (
    <>
      <svg style={{ height: 0 }}>
        <defs>
          <linearGradient id="gradientColor" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#FFAD46" />
            <stop offset="100%" stopColor="#903163" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgressbar
        value={value}
        text={`${value}%`}
        styles={{
          path: {
            stroke: "url(#gradientColor)",
          },
          trail: {
            stroke: "#d6d6d6",
            strokeWidth: 8,
          },
          text: {
            fill: "#000",
            fontSize: "16px",
            fontWeight: "bold",
          },
        }}
      />
    </>
  );
};

export default GradientCircularProgressbar;
